<mat-form-field class="mat-input-custom" appearance="outline">
  <mat-label>{{ label }}</mat-label>

  <input
    matInput
    aria-label="city"
    #autoCompleteInput
    [matAutocomplete]="cityAuto"
    [formControlName]="formControlNameData"
    [id]="idAutomation"
    appAlphabetOnly
    [readonly]="true"
  />
  <mat-autocomplete #cityAuto="matAutocomplete">
    <mat-option
      *ngFor="let city of filteredCityList | async"
      [value]="city.display_name"
    >
      <span>{{ city.display_name }}</span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
